import { genres } from "@/mocks/dramas";

type Props = {
  active: string;
  onChange: (slug: string) => void;
};

export default function CategoryFilter({ active, onChange }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="口味筛选">
      <span className="mr-1 text-xs font-label text-foreground-500">口味：</span>
      <button
        type="button"
        onClick={() => onChange("")}
        aria-pressed={active === ""}
        className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-label transition-colors cursor-pointer ${
          active === ""
            ? "bg-accent-500 text-background-950"
            : "border border-background-300/60 text-foreground-700 hover:border-accent-500/70"
        }`}
      >
        全部
      </button>
      {genres.map((genre) => (
        <button
          key={genre.slug}
          type="button"
          onClick={() => onChange(genre.slug)}
          aria-pressed={active === genre.slug}
          className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-label transition-colors cursor-pointer ${
            active === genre.slug
              ? "bg-accent-500 text-background-950"
              : "border border-background-300/60 text-foreground-700 hover:border-accent-500/70"
          }`}
        >
          {genre.name}
        </button>
      ))}
    </div>
  );
}